import { useMemo } from 'react';

/**
 * Custom hook to extract and structure page data from Strapi response
 * Centralizes data extraction logic to avoid repetition across pages
 */
export const usePageData = (strapiData) => {
    return useMemo(() => {
        if (!strapiData) {
            return {
                configData: {},
                pageData: {},
                header: {},
                footer: {},
                heroSection: null,
                generalContent: null,
                fleetData: null,
                trustedByData: null,
                servicesData: null,
                testimonialsData: null,
                howItWorksData: null,
                featuresData: null,
                ctaData: null,
                locationsData: null,
                faqData: { faqs: [] }
            };
        }

        const configData = strapiData.configData || {};
        const pageData = strapiData.pageData || {};
        
        return {
            configData,
            pageData,
            header: configData.header || {},
            footer: {
                ...(configData.footer || {}),
                hideMenu: configData.header?.hideMenu,
            },
            heroSection: pageData.EnhancedHeroSection || pageData.HeroSection,
            generalContent: pageData.General,
            fleetData: pageData?.Fleet?.[0],
            trustedByData: pageData.TrustedBy,
            servicesData: pageData.ServicesSection,
            testimonialsData: pageData.Testimonials,
            howItWorksData: pageData.HowItWorks,
            featuresData: pageData.FeaturesSec,
            ctaData: pageData.CTASection,
            locationsData: pageData.Locations?.[0] || pageData.locations?.[0],
            faqData: {
                faqs: pageData?.FAQ?.faqs || pageData?.faqs || pageData?.Faqs?.faqs || [],
            }
        };
    }, [strapiData]);
};

export default usePageData;
